import { render, staticRenderFns } from "./DashboardLoginDialog.vue?vue&type=template&id=356726b4&scoped=true&"
import script from "./DashboardLoginDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardLoginDialog.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLoginDialog.vue?vue&type=style&index=0&id=356726b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356726b4",
  null
  
)

export default component.exports